unit SchoolAccountEditPage;

interface

uses
  System.SysUtils,
  System.Classes,
  JS,
  Web,
  WEBLib.Graphics,
  WEBLib.Controls,
  WEBLib.Forms,
  WEBLib.Dialogs,
  EditBaseForm,
  Data.DB,
  WEBLib.DB,
  Vcl.StdCtrls,
  WEBLib.StdCtrls,
  Vcl.Controls,
  WEBLib.DBCtrls,
  WEBLib.ExtCtrls,
  WEBLib.Actions,
  WEBLib.WebCtrls;

type
  TSchoolAccountEditForm = class(TBaseEditForm)
    Add1: TDBEdit;
    Town: TDBEdit;
    PostCode: TDBEdit;
    Telephone: TDBEdit;
    Email: TDBEdit;
    RecordId: TDBLabel;
    SchoolId: TDBLabel;
    LocationName: TDBEdit;
  private
    { Private declarations }

  protected
    function GetRequiredEditLevel: string; override;

  public
    { Public declarations }
  protected procedure LoadDFMValues; override; end;

var
  SchoolAccountEditForm: TSchoolAccountEditForm;

implementation

{$R *.dfm}

uses
  App.Shared,
  App.Web.Utils;

function TSchoolAccountEditForm.GetRequiredEditLevel: string;
begin
  Result := GetStandardEditLevel;

end;

procedure TSchoolAccountEditForm.LoadDFMValues;
begin
  inherited LoadDFMValues;

  RecordId := TDBLabel.Create('record-id');
  SchoolId := TDBLabel.Create('school-id');
  Add1 := TDBEdit.Create('add-1');
  Town := TDBEdit.Create('town');
  PostCode := TDBEdit.Create('postcode');
  Telephone := TDBEdit.Create('telephone');
  Email := TDBEdit.Create('email');
  LocationName := TDBEdit.Create('location-name');

  RecordId.BeforeLoadDFMValues;
  SchoolId.BeforeLoadDFMValues;
  Add1.BeforeLoadDFMValues;
  Town.BeforeLoadDFMValues;
  PostCode.BeforeLoadDFMValues;
  Telephone.BeforeLoadDFMValues;
  Email.BeforeLoadDFMValues;
  LocationName.BeforeLoadDFMValues;
  try
    Name := 'SchoolAccountEditForm';
    RecordId.SetParentComponent(Self);
    RecordId.Name := 'RecordId';
    RecordId.Left := 40;
    RecordId.Top := 72;
    RecordId.Width := 47;
    RecordId.Height := 15;
    RecordId.Caption := 'RecordId';
    RecordId.ElementFont := efCSS;
    RecordId.ElementPosition := epIgnore;
    RecordId.HeightStyle := ssAuto;
    RecordId.HeightPercent := 100.000000000000000000;
    RecordId.Visible := False;
    RecordId.WidthStyle := ssAuto;
    RecordId.WidthPercent := 100.000000000000000000;
    RecordId.DataField := 'Id';
    SchoolId.SetParentComponent(Self);
    SchoolId.Name := 'SchoolId';
    SchoolId.Left := 256;
    SchoolId.Top := 72;
    SchoolId.Width := 46;
    SchoolId.Height := 15;
    SchoolId.Caption := 'SchoolId';
    SchoolId.ElementFont := efCSS;
    SchoolId.ElementPosition := epIgnore;
    SchoolId.HeightStyle := ssAuto;
    SchoolId.HeightPercent := 100.000000000000000000;
    SchoolId.Visible := False;
    SchoolId.WidthStyle := ssAuto;
    SchoolId.WidthPercent := 100.000000000000000000;
    SchoolId.DataField := 'SchoolId';
    Add1.SetParentComponent(Self);
    Add1.Name := 'Add1';
    Add1.Left := 40;
    Add1.Top := 152;
    Add1.Width := 121;
    Add1.Height := 22;
    Add1.ChildOrder := 3;
    Add1.ElementClassName := 'form-control';
    Add1.ElementFont := efCSS;
    Add1.ElementPosition := epIgnore;
    Add1.HeightStyle := ssAuto;
    Add1.HeightPercent := 100.000000000000000000;
    Add1.MaxLength := 100;
    Add1.Text := 'Add1';
    Add1.WidthStyle := ssAuto;
    Add1.WidthPercent := 100.000000000000000000;
    Add1.DataField := 'Add1';
    Add1.DataSource := DataSource;
    Town.SetParentComponent(Self);
    Town.Name := 'Town';
    Town.Left := 40;
    Town.Top := 180;
    Town.Width := 121;
    Town.Height := 22;
    Town.ChildOrder := 3;
    Town.ElementClassName := 'form-control';
    Town.ElementFont := efCSS;
    Town.ElementPosition := epIgnore;
    Town.HeightStyle := ssAuto;
    Town.HeightPercent := 100.000000000000000000;
    Town.MaxLength := 75;
    Town.Text := 'Town';
    Town.WidthStyle := ssAuto;
    Town.WidthPercent := 100.000000000000000000;
    Town.DataField := 'Town';
    Town.DataSource := DataSource;
    PostCode.SetParentComponent(Self);
    PostCode.Name := 'PostCode';
    PostCode.Left := 40;
    PostCode.Top := 208;
    PostCode.Width := 121;
    PostCode.Height := 22;
    PostCode.ChildOrder := 3;
    PostCode.ElementClassName := 'form-control';
    PostCode.ElementFont := efCSS;
    PostCode.ElementPosition := epIgnore;
    PostCode.HeightStyle := ssAuto;
    PostCode.HeightPercent := 100.000000000000000000;
    PostCode.MaxLength := 25;
    PostCode.Text := 'Postcode';
    PostCode.WidthStyle := ssAuto;
    PostCode.WidthPercent := 100.000000000000000000;
    PostCode.DataField := 'Postcode';
    PostCode.DataSource := DataSource;
    Telephone.SetParentComponent(Self);
    Telephone.Name := 'Telephone';
    Telephone.Left := 40;
    Telephone.Top := 236;
    Telephone.Width := 121;
    Telephone.Height := 22;
    Telephone.ChildOrder := 3;
    Telephone.EditType := weNumeric;
    Telephone.ElementClassName := 'form-control';
    Telephone.ElementFont := efCSS;
    Telephone.ElementPosition := epIgnore;
    Telephone.HeightStyle := ssAuto;
    Telephone.HeightPercent := 100.000000000000000000;
    Telephone.MaxLength := 25;
    Telephone.Text := 'Telephone';
    Telephone.WidthStyle := ssAuto;
    Telephone.WidthPercent := 100.000000000000000000;
    Telephone.DataField := 'Telephone';
    Telephone.DataSource := DataSource;
    Email.SetParentComponent(Self);
    Email.Name := 'Email';
    Email.Left := 40;
    Email.Top := 264;
    Email.Width := 121;
    Email.Height := 22;
    Email.ChildOrder := 3;
    Email.ElementClassName := 'form-control';
    Email.ElementFont := efCSS;
    Email.ElementPosition := epIgnore;
    Email.HeightStyle := ssAuto;
    Email.HeightPercent := 100.000000000000000000;
    Email.MaxLength := 320;
    Email.Text := 'Email';
    Email.WidthStyle := ssAuto;
    Email.WidthPercent := 100.000000000000000000;
    Email.DataField := 'Email';
    Email.DataSource := DataSource;
    LocationName.SetParentComponent(Self);
    LocationName.Name := 'LocationName';
    LocationName.Left := 40;
    LocationName.Top := 124;
    LocationName.Width := 121;
    LocationName.Height := 22;
    LocationName.ChildOrder := 3;
    LocationName.ElementClassName := 'form-control';
    LocationName.ElementFont := efCSS;
    LocationName.ElementPosition := epIgnore;
    LocationName.HeightStyle := ssAuto;
    LocationName.HeightPercent := 100.000000000000000000;
    LocationName.MaxLength := 255;
    LocationName.Text := 'LocationName';
    LocationName.WidthStyle := ssAuto;
    LocationName.WidthPercent := 100.000000000000000000;
    LocationName.DataField := 'LocationName';
    LocationName.DataSource := DataSource;
  finally
    RecordId.AfterLoadDFMValues;
    SchoolId.AfterLoadDFMValues;
    Add1.AfterLoadDFMValues;
    Town.AfterLoadDFMValues;
    PostCode.AfterLoadDFMValues;
    Telephone.AfterLoadDFMValues;
    Email.AfterLoadDFMValues;
    LocationName.AfterLoadDFMValues;
  end;
end;

end.